import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.873 3.067a.7.7 0 0 1 .38.805L12.9 9.225h4.351a.7.7 0 0 1 .585 1.085L11.01 20.685a.7.7 0 0 1-1.27-.533l1.392-6.414H6.75a.7.7 0 0 1-.565-1.114l6.825-9.337a.7.7 0 0 1 .863-.22m-5.744 9.27H12a.7.7 0 0 1 .684.849l-.778 3.59 4.046-6.151H12a.7.7 0 0 1-.679-.872l.69-2.728z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=TriggerIcon24.js.map